import { MODAL_TYPE } from 'config/Constants';
import { useStore } from 'hooks/useStore';
import { bulkUploadDataValidationInterfaceInstance } from 'Interfaces/JobsInterface/index';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { JobPasteServices } from 'services/jobPasteServices';

let frontendUrl;
if (import.meta.env.VITE_MODE == 'dev') {
  frontendUrl = import.meta.env.VITE_FRONTEND_ENDPOINT;
} else {
  frontendUrl = window.config.frontendBaseUrl;
}

export const useBulkJobUpload = () => {
  const [fileUploaded, setFiledUploaded] = useState(false);
  const [validationData, setValidationData] = useState<bulkUploadDataValidationInterfaceInstance[]>(
    []
  );

  const { GlobalModalStore } = useStore();
  const { getCurrentInstance, toggleModal } = GlobalModalStore;

  const visibility = getCurrentInstance(MODAL_TYPE.PPS_JPB_PASTE_BULK_UPLOAD_JOBS_MODAL);

  const [isFileUploading, setIsFileUploading] = useState(false);

  const handleDownloadTemplate = () => {
    // Step 3: Create a link element
    const link = document.createElement('a');
    if (frontendUrl.length && frontendUrl[frontendUrl.length - 1] === '/') {
      link.href = `${frontendUrl}pps/bulk-upload-pps.xlsx`;
    } else {
      link.href = `${frontendUrl}/pps/bulk-upload-pps.xlsx`;
    }
    link.download = 'bulk-upload-pps.xlsx'; // Name of the file to download
    // Step 4: Append the link to the DOM, trigger click, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fileUploadCallback = (data: bulkUploadDataValidationInterfaceInstance[]) => {
    setFiledUploaded(true);
    setValidationData(data);
  };

  const cancelUploadedFileCallback = () => {
    setFiledUploaded(false);
  };

  const handleUploadFile = async (file: File) => {
    if (file) {
      try {
        setIsFileUploading(true);
        const formData = new FormData();
        formData.append('file', file);
        const preview_response = await JobPasteServices.getPpsBulkUpdatePreviewData(formData);
        setValidationData(preview_response.data);
        setFiledUploaded(true);
      } catch (err) {
        toast.error(
          'The data file uploaded is not in the correct expected format, please verify it once and then upload'
        );
      } finally {
        setIsFileUploading(false);
      }
    }
  };

  const onClose = () => toggleModal(MODAL_TYPE.PPS_JPB_PASTE_BULK_UPLOAD_JOBS_MODAL);

  return {
    fileUploaded,
    fileUploadCallback,
    validationData,
    handleDownloadTemplate,
    isFileUploading,
    handleUploadFile,
    visibility,
    onClose,
    cancelUploadedFileCallback
  };
};
